// BlogPost.js
export const BlogPost = {
  list: async (sort) => {
    // Dummy data for demonstration
    return [
      { id: 1, title: "First Post", created_date: "2025-01-01" },
      { id: 2, title: "Second Post", created_date: "2025-02-01" }
    ];
  }
};
